import i18next, {InitOptions} from "i18next";
import {initReactI18next} from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import portalConfiguration from "../configuration/PortalConfiguration";
import UrlHelper from "../helper/UrlHelper";
import UrlParameter from "../UrlParameter";
import {addLocale} from "primereact/api";
import StorageItem from "../StorageItem";
import FunctionHelper from "../helper/FunctionHelper";
import {Language} from "./i18nInterface";

/**
 * Change the current language to the given {@link Language}
 */
export const changeLanguage = async (lng: Language) => {
	await i18next.changeLanguage(lng);
}

/**
 * Initializes the {@link i18next} translation
 */
export const i18nInit = async () => {
	await i18next
	// load translation using http -> see /public/locales
	// (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		backend: {
			loadPath: "locales/{{lng}}/{{ns}}" + portalConfiguration.cachingPath + ".json"
		},
		defaultNS: "general",
		ns: ["general", "dialog", "help", "menu", "message", "screen", "sidebar"],
		order: ["localStorage", "sessionStorage", "navigator", "htmlTag", "path", "subdomain"],
		lookupLocalStorage: StorageItem.LANGUAGE,
		lng: FunctionHelper.applyValue(localStorage.getItem(StorageItem.LANGUAGE), portalConfiguration.defaultLanguage),
		fallbackLng: portalConfiguration.fallbackLanguage,
		whitelist: portalConfiguration.availableLanguages,
		debug: portalConfiguration.debug,
		react: {
			transSupportBasicHtmlNodes: true,
			transEmptyNodeValue: ""
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		}
	} as InitOptions);

	let lang: string | null = FunctionHelper.applyValue(
		UrlHelper.getSearchParam(UrlParameter.LANGUAGE), localStorage.getItem(StorageItem.LANGUAGE),
		portalConfiguration.defaultLanguage
	);

	if (FunctionHelper.exists(lang) && Object.values(Language).includes(lang as Language)) {
		await changeLanguage(lang as Language);
	}

	addLocale(Language.GERMAN, {
		firstDayOfWeek: 1,
		dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
		dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
		dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
		monthNames: [
			"Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November",
			"Dezember"
		],
		monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
		today: "Heute",
		clear: "Leeren"
	});
}

export default i18next;